import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface IndustryHeroProps {
  title: string;
  description: string;
}

const IndustryHero: React.FC<IndustryHeroProps> = ({ title, description }) => {
  return (
    <section className="relative bg-gradient-to-br from-primary via-secondary to-brand-primary py-20 lg:py-28">
      <div className="absolute inset-0 bg-black/10"></div>
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center space-x-2 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full mb-6">
            <Icon name="BriefcaseIcon" size={20} className="text-white" />
            <span className="text-sm font-cta font-semibold text-white">Industry-Specific Solutions</span>
          </div>
          <h1 className="text-4xl lg:text-5xl xl:text-6xl font-headline font-bold text-white mb-6 leading-tight">
            {title}
          </h1>
          <p className="text-lg lg:text-xl text-white/90 font-body leading-relaxed max-w-3xl mx-auto">
            {description}
          </p>
        </div>
      </div>
    </section>
  );
};

export default IndustryHero;